import { mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { LinkText } from '../typography';

const mobileHeight = `max-height: 650px`;

export const CallAgentModalContainer = styled.div<{ multiAgent: boolean }>`
  width: 100%;
  text-align: left;
  padding: ${({ multiAgent }) => (multiAgent ? '15px' : '100px')} 15px;

  @media screen and (${mobileXLargeMax}) {
    padding: 50px 15px;
  }

  @media (${mobileHeight}) {
    padding: 15px;
  }
`;

export const CallAgentModalTitle = styled.p`
  width: 100%;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.textDark};
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  position: absolute;
  top: 0;
  top: -56px;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const CallAgentModalImage = styled.img<{ multiAgent: boolean }>`
  width: 100%;
  max-width: ${({ multiAgent }) => (multiAgent ? '150px' : '200px')};
  margin: 16px auto;
  display: flex;

  @media (${mobileHeight}) {
    max-width: 150px;
    margin-top: 0px;
  }
`;

export const CallAgentModalOption = styled.div`
  color: ${({ theme }) => theme.textDark};
  font-size: 16px;
  margin: 5px 0px;
  text-align: center;
`;

export const ContactText = styled.span<{ multiAgent: boolean }>`
  font-size: ${({ multiAgent }) => (multiAgent ? '18px' : '24px')};
  line-height: 1.25;
  text-align: center;

  @media screen and (${mobileXLargeMax}) {
    font-size: 18px;
  }
`;

export const ContactNumber = styled(LinkText)<{ multiAgent: boolean }>`
  margin-top: ${({ multiAgent }) => (multiAgent ? '25px' : '50px')};
  font-size: ${({ multiAgent }) => (multiAgent ? '22px' : '34px')};
  font-weight: bold;
  display: block;
  color: ${(props) => props.theme.textDark};
  text-decoration: none;

  @media (${mobileXLargeMax}), (${mobileHeight}) {
    margin-top: 25px;
    font-size: 22px;
  }
`;
